<script>
	// Stores
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let market;

	let cashoutEnabled = $MarketStore && market && market.cashout_enabled;

	function updateCashout() {
		MarketStore.updateMarketCashout(market.id, cashoutEnabled)
			.then((marketResponse) => {
				if (cashoutEnabled && marketResponse.cashout_enabled == false) {
					cashoutEnabled = marketResponse.cashout_enabled;
					notify({
						type: 'danger',
						title: `${market.name}`,
						message: 'Failed to update Cashout',
						timeout: 3
					});
				} else {
					notify({
						type: 'success',
						title: `${market.name}`,
						message: `Cashout for Market updated to ${cashoutEnabled ? 'On' : 'Off'}`,
						timeout: 3
					});
				}
			})
			.catch(() => {
				cashoutEnabled = !cashoutEnabled;
				notify({
					type: 'danger',
					title: `${market.name}`,
					message: 'Failed to update Cashout',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center justify-between">
	<div class="text-xs font-semibold uppercase">Cashout</div>
	<Switch
		on:change={updateCashout}
		name={`enable-market-cashout-${market.id}`}
		bind:checked={cashoutEnabled}
		small={true}
		className=""
	/>
</div>
